import { useMemo } from 'react';
import type { UseMagazineFilterArticles } from './interfaces';

const useMagazineFilterArticles: UseMagazineFilterArticles = (
  articlesData,
  category,
  selectedTags
) => {
  const filteredArticles = useMemo(
    () =>
      articlesData.filter(
        (article) =>
          (category ? article.category === category : true) &&
          (selectedTags.length
            ? selectedTags.some((tag) => article.tags?.includes(tag))
            : true)
      ),
    [articlesData, category, selectedTags]
  );

  return {
    filteredArticles,
  };
};

export default useMagazineFilterArticles;
